var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-label', [_vm._v("Группировка")]), _c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "text",
      "items": _vm.groupByOptions
    },
    model: {
      value: _vm.groupBy,
      callback: function ($$v) {
        _vm.groupBy = $$v;
      },
      expression: "groupBy"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-label', [_vm._v("Сравнить с периодом")]), _c('DateField', {
    attrs: {
      "range": true,
      "clearable": ""
    },
    model: {
      value: _vm.periodB,
      callback: function ($$v) {
        _vm.periodB = $$v;
      },
      expression: "periodB"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "funnel-row"
  }, [_c('div', {
    staticClass: "funnel-item"
  }, [_c('FunnelChart', {
    attrs: {
      "title": "Текущий период",
      "stages": _vm.funnelA.stages,
      "contract-amount": _vm.funnelA.contractAmount,
      "loading": _vm.loading
    }
  })], 1), _vm.hasPeriodB ? _c('div', {
    staticClass: "funnel-item"
  }, [_c('FunnelChart', {
    attrs: {
      "title": "Период сравнения",
      "stages": _vm.funnelB.stages,
      "contract-amount": _vm.funnelB.contractAmount,
      "loading": _vm.loadingB
    }
  })], 1) : _vm._e()])])], 1), _vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "table-row@5"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "border-left": "thin solid rgba(255, 255, 255, 0.18) !important"
    }
  }, [_c('v-data-table', {
    staticClass: "table__lined",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var items = _ref.items;
        return [_c('tbody', _vm._l(items, function (item, i) {
          return _c('tr', {
            key: i
          }, [_c('td', [_vm._v(_vm._s(_vm.groupLabel(item)))]), _c('td', [_vm._v(_vm._s(item.totalLeads))]), _c('td', [_vm._v(_vm._s(item.callLeads))]), _c('td', [_vm._v(_vm._s(item.robotLeads))]), _c('td', [_vm._v(_vm._s(item.chatLeads))]), _c('td', [_vm._v(_vm._s(item.formLeads))]), _c('td', [_vm._v(" " + _vm._s(item.withProblemFilled) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.problemFilledRate))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(_vm._s(item.notReached))]), _c('td', [_vm._v(" " + _vm._s(item.scheduled) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.scheduledRate))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(" " + _vm._s(item.came) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.cameRate))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(_vm._s(item.notCame))]), _c('td', [_vm._v(" " + _vm._s(item.rejected) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.rejectedRate, true))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(" " + _vm._s(item.hasClient) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.clientRate))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(" " + _vm._s(item.contracts) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.percentHtml(item.contractRate))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(_vm._s(item.contractAmount.toLocaleString('ru-RU')) + " ₽")])]);
        }), 0)];
      }
    }], null, false, 2015936046)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }